import PropTypes from 'prop-types'
import React from 'react'

import Box from '@mui/material/Box'

const L4L = ({ isL4L }) => (isL4L ? <Box className="icon l4l-small-icon tablet-portrait-up-only" /> : null)

L4L.propTypes = {
  isL4L: PropTypes.bool,
}

export default L4L
